// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    BadgePlus,
    BadgePoundSterling,
    BadgeQuestionMark,
    BadgeRussianRuble,
    BadgeSwissFranc,
    BadgeTurkishLira,
    BadgeX,
    BaggageClaim,
    Balloon,
    Ban,
    Banana,
    Bandage,
    Banknote,
    BanknoteArrowDown,
    BanknoteArrowUp,
    BanknoteCheck,
    BanknoteX,
    Barcode,
    Barrel,
    Baseline,
    Bath,
    Battery,
    BatteryCharging,
    BatteryFull,
    BatteryLow,
    BatteryMedium,
    BatteryPlus,
    BatteryWarning,
    Beaker,
    Bean,
    BeanOff,
    Bed,
    BedDouble,
    BedSingle,
    Beef,
    BeefOff,
    Beer,
    BeerOff,
    Bell,
    BellCheck,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "badge-plus" through "bell-check", inclusive. */
const shard: Record<string, LucideIcon> = {
    "badge-plus": BadgePlus,
    "badge-pound-sterling": BadgePoundSterling,
    "badge-question-mark": BadgeQuestionMark,
    "badge-russian-ruble": BadgeRussianRuble,
    "badge-swiss-franc": BadgeSwissFranc,
    "badge-turkish-lira": BadgeTurkishLira,
    "badge-x": BadgeX,
    "baggage-claim": BaggageClaim,
    balloon: Balloon,
    ban: Ban,
    banana: Banana,
    bandage: Bandage,
    banknote: Banknote,
    "banknote-arrow-down": BanknoteArrowDown,
    "banknote-arrow-up": BanknoteArrowUp,
    "banknote-check": BanknoteCheck,
    "banknote-x": BanknoteX,
    barcode: Barcode,
    barrel: Barrel,
    baseline: Baseline,
    bath: Bath,
    battery: Battery,
    "battery-charging": BatteryCharging,
    "battery-full": BatteryFull,
    "battery-low": BatteryLow,
    "battery-medium": BatteryMedium,
    "battery-plus": BatteryPlus,
    "battery-warning": BatteryWarning,
    beaker: Beaker,
    bean: Bean,
    "bean-off": BeanOff,
    bed: Bed,
    "bed-double": BedDouble,
    "bed-single": BedSingle,
    beef: Beef,
    "beef-off": BeefOff,
    beer: Beer,
    "beer-off": BeerOff,
    bell: Bell,
    "bell-check": BellCheck,
};

export default shard;
